<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">{{ $t('events.forms.chooseType') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor"/>
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor"/>
                    </svg>
                </span>
              </div>
            </div>
            <div class="modal-body">
            <div class="row">
                <div v-for="(el, index) in types" class="col" :key="index">
                    <Card class="cursor-pointer" :variant="getVariant(el.id)"  @click.prevent="type = el.id">
                        <div class="text-center py-5">
                            <span class="font-bold font-white fs-2"> {{ el.type[locale] }} </span>
                        </div>
                    </Card>
                </div>
            </div>
            </div>
            <div class="modal-footer">
                <Button type="cancel"  id="cancel_btn" btn-class="btn-sm" data-bs-dismiss="modal"  size="7px 30px" btn-text="button.cancel"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="processing" @click="openCreateView"></Button>
            </div>
        </div>
        </div>
  </div>
</template>

<script setup>
import Button from '@/components/Button.vue';
import Card from '@/components/Card.vue';
import { useLocales } from '@/composables/locales';
import { ref } from 'vue';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';


const route = useRoute()
const router = useRouter()
const store = useStore()
const {locale} = useLocales()

const props = defineProps({
    id: {type: String, default: "kt_forms_type"}
})

const type = ref('')
const processing = ref(false)

const types = computed(() => store.getters['forms/formTypes'])

const getVariant = (id) => type.value == id ? 'primary' : 'gray'

const openCreateView = () => {  
    processing.value = true
    store.dispatch('forms/getTypeDefaultForm', {type: type.value, event_id: route.params.id}).then((resp) => {
        $("#"+props.id).modal("toggle")
        router.push({name: 'events-form-update', params: {id: route.params.id, form: resp.data.id}})
    })
    .finally(() => processing.value = false)
  
}
</script>